import axios from "axios";
import { BASE_URL } from "./Constants";

const instance = axios.create({
  withCredentials: true,
  baseURL: BASE_URL,
});

export async function updatePerso(formData) {
  try {
    // const token = Cookies.get("user");
    const response = await instance.post(`/persos`, formData, {
      headers: {
        "content-type": "multipart/form-data",
      },
    });

    const data = response.data;
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function updateDico(body) {
  try {
    // const token = Cookies.get("user");
    const response = await instance.post(`/dicos`, body, {
      headers: {
        "content-type": "application/json",
      },
    });

    const data = response.data;
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function updateStickers(formData, queryParams) {
  // https://newbrand.s3.eu-west-3.amazonaws.com/shared/LULU_KROY/PL_30_DESTINS_AVENTURIERS/season-1/ep-1/ILLU_BONJOUR_ASTRONAUTE.png
  try {
    // const token = Cookies.get("user");
    const url = encodeURI(
      `/stickers?numEp=${queryParams.numEp}&numSeason=${queryParams.numSeason}&uidSerie=${queryParams.uidSerie}&uidCollection=${queryParams.uidCollection}`
    );
    const response = await instance.post(url, formData, {
      headers: {
        "content-type": "multipart/form-data",
      },
    });

    const data = response.data;
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function putCollection(uidCollection, data) {
  try {
    const response = await instance.put(`/collection/${uidCollection}`, data);
    return response.data;
  } catch (error) {
    console.error(error);
  }
}
